interface IconProps {
  className?: string;
}

/**
 * Shopping cart glyph, filled. Inlined because the shared sprite
 * (~/components/Icon) does not include a solid shopping-cart icon.
 */
const ShoppingCartIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden className={className}>
    <path
      d="M6.66602 15.833C7.58638 15.833 8.33283 16.5787 8.33301 17.499C8.33301 18.4195 7.58649 19.166 6.66602 19.166C5.74569 19.1658 5 18.4194 5 17.499C5.00018 16.5788 5.7458 15.8332 6.66602 15.833Z"
      fill="currentColor"
    />
    <path
      d="M15.833 15.833C16.7534 15.833 17.4998 16.5787 17.5 17.499C17.5 18.4195 16.7535 19.166 15.833 19.166C14.9125 19.166 14.166 18.4195 14.166 17.499C14.1662 16.5787 14.9126 15.833 15.833 15.833Z"
      fill="currentColor"
    />
    <path
      d="M3.51953 0.887695C3.84862 0.945636 4.11738 1.19727 4.18945 1.5332L4.94043 5.04102H18.4082C18.6609 5.04107 18.8995 5.15643 19.0576 5.35352C19.2158 5.55066 19.2765 5.80893 19.2217 6.05566L17.8467 12.2471L17.8457 12.2461C17.7233 12.8014 17.4156 13.2986 16.9727 13.6553C16.5295 14.0119 15.978 14.2071 15.4092 14.208H7.25781C6.68299 14.2165 6.1223 14.0265 5.6709 13.6699C5.21474 13.3095 4.89832 12.8009 4.77637 12.2324L2.7002 2.54102H1.70801C1.24777 2.54102 0.875 2.16825 0.875 1.70801C0.875 1.24777 1.24777 0.875 1.70801 0.875H3.375L3.51953 0.887695Z"
      fill="currentColor"
    />
  </svg>
);

export default ShoppingCartIcon;
